// Page view interfaces
export var QueryFilterComparisonType;
(function (QueryFilterComparisonType) {
    QueryFilterComparisonType["COSINE_SIMILARITY"] = "cosineSimilarity";
    QueryFilterComparisonType["LOGISTIC_REGRESSION"] = "logisticRegression";
})(QueryFilterComparisonType || (QueryFilterComparisonType = {}));
// Storage interfaces
export var StorageKeys;
(function (StorageKeys) {
    StorageKeys["PAGE_VIEWS"] = "edkt_page_views";
    StorageKeys["MATCHED_AUDIENCES"] = "edkt_matched_audiences";
    StorageKeys["MATCHED_AUDIENCE_IDS"] = "edkt_matched_audience_ids";
    StorageKeys["CACHED_AUDIENCES"] = "edkt_cached_audiences";
    StorageKeys["CACHED_AUDIENCE_META_DATA"] = "edkt_cached_audience_meta_data";
})(StorageKeys || (StorageKeys = {}));
//# sourceMappingURL=index.js.map